import { ItemMiddleAttrListDataSet, TableDataColumn } from '@mri/types';


function _getValue(prop: ItemMiddleAttrListDataSet, column: TableDataColumn): string | number | boolean | null {
  if (typeof column.getMiddleValue === 'function') return column.getMiddleValue(prop);

  return null;
}

export function tableGetMiddleRender(prop: ItemMiddleAttrListDataSet, column: TableDataColumn): string | number | boolean | null {
  const value = _getValue(prop, column);

  if (typeof value === 'number') return value.toFixed(2);

  return value;
}

